import { ApiClient } from '@webapp/core/services/ApiClient'
import { CardRepository } from '@webapp/modules/spending-cards/data-access/repositories/CardRepository/CardRepository'

export const cardRepository = new CardRepository({
  httpClient: ApiClient,
})
